import { Button, PresetThemes } from '@travelnest/merlin.button';
import { Rule } from '@travelnest/merlin.rule';
import * as React from 'react';

import { useNavigate } from 'react-router-dom';
import { Form } from '../../../components/form';
import { Content } from '../../../components/page/content/Content';

export const ResetSuccess: React.FC = () => {

	const navigate = useNavigate();

	return (
		<>
			<Content>
				<h1 className="login__title-text">Reset Password</h1>
				<Rule />
				<p>
					Your password has been successfully reset. Please continue
					to the login screen where you can log in with your new
					password.
				</p>
				<Form onSubmit={(e) => e.preventDefault()}>
					<p>
						<Button
							buttonType={PresetThemes.Primary}
							onClick={() => navigate('/login')}
						>
							Back to login
						</Button>
					</p>
				</Form>
			</Content>
		</>
	);
};
